import Message from "../../message";
import EventBus from "@/services/eventBus";

export default class AdRewardVerified extends Message
{
    handle()
    {
        EventBus.emit('ad-reward-verified', this.message);
    }
}
